var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Editar Aplicaciones Cliente" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c(
            "v-btn",
            {
              staticStyle: { "max-height": "75%" },
              attrs: { color: "#ff6c04" },
              on: {
                click: function($event) {
                  return _vm.confirmAplicaciones()
                }
              }
            },
            [
              _c("span", { staticStyle: { color: "white" } }, [
                _vm._v("Guardar Cambios")
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.permisosApps.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.permisosApps, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.vehiculos.visible,
                      expression: "pasos.vehiculos.visible"
                    }
                  ],
                  attrs: { color: "primary", flat: "" },
                  on: { click: _vm.handleShowVehiculos }
                },
                [
                  _c("span", [_vm._v("Vehiculos")]),
                  _c("v-icon", [_vm._v("local_shipping")])
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.infoGral.visible,
                      expression: "pasos.infoGral.visible"
                    }
                  ],
                  attrs: { color: "primary", flat: "" },
                  on: { click: _vm.handleShowInfoGral }
                },
                [
                  _c("span", [_vm._v("Información General")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.permisosApps.visible,
                      expression: "pasos.permisosApps.visible"
                    }
                  ],
                  attrs: { color: "primary", flat: "" },
                  on: { click: _vm.handleShowPermisos }
                },
                [
                  _c("span", [_vm._v("Permisos Aplicaciones")]),
                  _c("v-icon", [_vm._v("apps")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "cardnew" },
        [
          _c("br"),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showInfoGral,
                  expression: "showInfoGral"
                }
              ]
            },
            [
              _c("TablaInfoGral", {
                attrs: { cliente: _vm.detalleSeleccionado },
                on: { guardar: _vm.savecliente }
              })
            ],
            1
          ),
          _vm.showVehiculos
            ? _c("DetalleForm", {
                attrs: {
                  detalleSeleccionado: _vm.detalleSeleccionado,
                  isVerDetalle: true
                }
              })
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPermisos,
                  expression: "showPermisos"
                }
              ],
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "align-item": "center"
              }
            },
            [
              _c("v-card", { staticStyle: { width: "70%" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.muestraBotonRolesEditar,
                        expression: "muestraBotonRolesEditar"
                      }
                    ]
                  },
                  [
                    _c("ag-grid-vue", {
                      staticClass: "ag-theme-material",
                      staticStyle: { "font-family": "'Asap', sans-serif" },
                      attrs: { gridOptions: _vm.gridOptions }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }